const MAX_GUEST_ORDER_MENU_QUANTITY = 999;

export const clampGuestOrderMenuQuantity = (value: number) =>
  Math.max(0, Math.min(value, MAX_GUEST_ORDER_MENU_QUANTITY));

export const parseGuestOrderMenuQuantityInput = (value: string) => {
  const digits = value.replace(/\D/g, "");
  if (!digits) return 0;
  return clampGuestOrderMenuQuantity(Number.parseInt(digits, 10));
};
